export { AlarmSettings } from './AlarmSettings/AlarmSettings';
export { EnrollmentSettings } from './EnrollmentSettings/EnrollmentSettings';
export { EventSettings } from './EventSettings/EventSettings';
export { GeneralSettings } from './GeneralSettings/GeneralSettings';
export { SecuritySettings } from './SecuritySettings/SecuritySettings';
export { PhotoCallUpSettings } from './PhotoCallUpSettings/PhotoCallUpSettings';
export { StatusDashboardSettings } from './StatusDashboardSettings/StatusDashboardSettings';
